import { useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const SingContract = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const iframeRef = useRef<HTMLIFrameElement | null>(null);

    const url = location.state?.url as string | undefined;

    const targetOrigin = useMemo(() => {
        if (!url) return null;
        try {
            return new URL(url).origin;
        } catch {
            return null;
        }
    }, [url]);

    useEffect(() => {
        if (!targetOrigin) return;

        const onMessage = (event: MessageEvent) => {
            const iframeWindow = iframeRef.current?.contentWindow;
            if (!iframeWindow) return;
            if (event.origin !== targetOrigin) return;
            if (event.source !== iframeWindow) return;

            let messageData: any = event.data;
            if (typeof event.data === 'string') {
                try {
                    messageData = JSON.parse(event.data);
                } catch {
                    console.warn('Failed to parse message:', event.data);
                    return;
                }
            }

            const status = messageData?.data?.status || messageData?.status;
            if (!status) return;

            if (status === '13' || status === 13) {
                navigate('/change-ownership/feedback?status=SING_CONTRACT');
                return;
            }

            if (['3', '7', '12', 3, 7, 12].includes(status)) {
                navigate('/change-ownership/feedback?status=FAILED_INTERESTED');
                return;
            }
        };

        window.addEventListener('message', onMessage);
        return () => {
            window.removeEventListener('message', onMessage);
        };
    }, [targetOrigin]);

    return (
        <div className='sign-contract' style={{ height: '100%', width: '100%' }}>
            <iframe
                id='sign-contract'
                name='sign-contract'
                ref={iframeRef}
                src={url}
                title='Digital contract signing'
                height={'100%'}
                width={'100%'}
            ></iframe>
        </div>
    );
};

export default SingContract;
